import { Transform } from '../types/core'

export interface RowContent {
  leftSide: boolean
  rightSide: boolean
}

export const justifyContent: Transform<RowContent, string> = ({ leftSide, rightSide }) =>
  leftSide && rightSide ? 'space-between' : rightSide ? 'flex-end' : 'flex-start'
